<template>
  <div class="loader_container" v-if="shouldShowLoader">
    <div class="loader">
      <div class="spinner-border" data-chromatic="ignore">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { mapState } from 'pinia'
import { useLoadingStore } from '@app/stores/LoadingStore'
import _ from 'lodash'

// Time to wait before showing the loader in milliseconds
const WAIT_TO_SHOW_LOADER = parseInt(process.env.VUE_APP_WAIT_TO_SHOW_LOADER || '250')

export default {
  data() {
    return {
      // Whether the loader should be shown
      showLoader: false,
    }
  },
  computed: {
    ...mapState(useLoadingStore, ['loading']),
    ...mapState(useLoadingStore, ['loaderQueue']),
    shouldShowLoader() {
      return this.showLoader && this.loading
    },
  },
  created() {
    // Create debounced function to show loader
    this.debouncedShowLoader = _.debounce(() => {
      this.showLoader = true
    }, WAIT_TO_SHOW_LOADER)
  },
  watch: {
    loading(newValue) {
      if (newValue) {
        // Call the debounced function to show loader after delay
        this.debouncedShowLoader()
      } else {
        // Cancel the debounced function if loading stops
        this.debouncedShowLoader.cancel()

        // Hide the loader
        this.showLoader = false
      }
    },
  },
  beforeUnmount() {
    // Clean up debounced function when component is destroyed
    if (this.debouncedShowLoader) {
      this.debouncedShowLoader.cancel()
    }
  },
}
</script>
<style lang="sass" scoped>
.loader_container
  position: absolute
  display: flex
  align-items: center
  justify-content: center
  background: rgba(255, 255, 255, 0.8)
  top: 0px
  left: 0px
  bottom: 0px
  right: 0px
  z-index: 10000000
  .spinner-border
    color: var(--uePurple)
    width: 3rem
    height: 3rem
</style>
